import { render, staticRenderFns } from "./left-share.vue?vue&type=template&id=65bafd0d&scoped=true&"
import script from "./left-share.vue?vue&type=script&lang=js&"
export * from "./left-share.vue?vue&type=script&lang=js&"
import style0 from "./left-share.vue?vue&type=style&index=0&id=65bafd0d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bafd0d",
  null
  
)

export default component.exports